module.exports = __webpack_public_path__ + "img/img15.329b0539.svg";